var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEnquiry(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17270",
    "data-name": "Rectangle 17270",
    width: 16.321,
    height: 15.735,
    transform: "translate(-2 -2)",
    fill: "none",
    stroke: "#a2a2a2",
    strokeWidth: 1.1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Enquiry"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Enquiry",
    clipPath: "url(#clip-Enquiry)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_22566",
    "data-name": "Group 22566",
    transform: "translate(2 2)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_28753",
    "data-name": "Path 28753",
    d: "M7.494,11.012A.416.416,0,0,0,7.614,11,4.35,4.35,0,0,0,9.9,9.593a4.243,4.243,0,0,0,.668-1.056.255.255,0,0,1,.1-.124,5.642,5.642,0,0,0,1-.759,3.136,3.136,0,0,0,.632-.818,1.674,1.674,0,0,0-.038-1.67,3.318,3.318,0,0,0-.639-.791,5.028,5.028,0,0,0-.458-.383M1.836,4a4.782,4.782,0,0,0-.658.585,2.881,2.881,0,0,0-.47.65A1.646,1.646,0,0,0,.682,6.787a2.866,2.866,0,0,0,.5.7,5.56,5.56,0,0,0,1.285,1,.425.425,0,0,0,.07.035.1.1,0,0,0,.147-.09,1.231,1.231,0,0,0,0-.138q0-2.219,0-4.438A1.247,1.247,0,0,1,2.7,3.628a3.831,3.831,0,0,1,.2-.7,3.7,3.7,0,0,1,1.614-1.9A3.917,3.917,0,0,1,7.046.538a3.742,3.742,0,0,1,2.989,2.215,3.016,3.016,0,0,1,.283,1.288c-.014,1.225,0,2.451,0,3.676m-3.99,4.194a1.056,1.056,0,0,0,.12-.015c.255-.059.511-.118.764-.182a.416.416,0,0,0,.318-.513q-.036-.173-.082-.345a.414.414,0,0,0-.509-.312q-.4.089-.8.19a.414.414,0,0,0-.313.5c.025.121.055.242.087.361A.408.408,0,0,0,6.324,11.912Z",
    transform: "translate(-0.338 -0.339)",
    fill: "none",
    stroke: "#a2a2a2",
    strokeMiterlimit: 10,
    strokeWidth: 1.1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnquiry);
export default __webpack_public_path__ + "static/media/Enquiry.fab07ddf7ee3529a1b8a70a0d1dd9f1b.svg";
export { ForwardRef as ReactComponent };